import { apiClient } from "@/lib/apiClient";
import { queryKeys } from "@/lib/query";
import type {
  RegisterWalletOwnerKeyPayload,
  RegisterWalletOwnerKeyResponse,
} from "@/types/api/wallet";
import { useApiTransactionMutation } from "./useApiTransactionMutation";

export function registerWalletOwnerKeyPath(
  entityType: RegisterWalletOwnerKeyPayload["entityType"],
) {
  return entityType === "merchant"
    ? "/merchants/me/wallet"
    : "/financiers/me/wallet";
}

export function useRegisterWalletOwnerKey() {
  return useApiTransactionMutation<
    RegisterWalletOwnerKeyPayload,
    RegisterWalletOwnerKeyResponse
  >(
    ({ ownerPublicKey, entityType }) =>
      apiClient.postData<RegisterWalletOwnerKeyResponse>(
        registerWalletOwnerKeyPath(entityType),
        { ownerPublicKey },
      ),
    ({ entityId, entityType }) => [
      entityType === "merchant" && entityId
        ? { queryKey: queryKeys.merchants.detail(entityId) }
        : undefined,
      entityType === "financier" && entityId
        ? { queryKey: queryKeys.financiers.detail(entityId) }
        : undefined,
    ],
  );
}
